/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralMultiCurrencyMarkupFeesRepository = (
    options: GeneralRestApiOptions
): Types.GeneralMultiCurrencyMarkupFeesRepository => ({
    async get(params, requestOptions) {
        return options.request('/multiCurrencyMarkupFees/get', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async update(params, requestOptions) {
        return options.request('/multiCurrencyMarkupFees/update', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async upsert(params, requestOptions) {
        return options.request('/multiCurrencyMarkupFees/upsert', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
